var map = {
	"./IN.json": 1418,
	"./IT.json": 1419,
	"./africa.json": 1420,
	"./continent.json": 1421,
	"./europe.json": 1422,
	"./north-america.json": 1423,
	"./world-low-res.json": 1424,
	"./world.json": 1425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;